import AppBar from '@material-ui/core/AppBar'
import { alpha, makeStyles } from '@material-ui/core/styles'
import { SearchNormal1 as SearchIcon } from 'iconsax-react'
import React, { useEffect, useState } from 'react'
import { Avatar, InputAdornment, TextField, Button } from '@material-ui/core'
import AuthDilog from './AuthModal'
import { useHistory } from 'react-router-dom'
import Autocomplete from '@material-ui/lab/Autocomplete'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'
import DialogAlert from '../../components/common/DialogAlert'
import { withNamespaces } from 'react-i18next'
import i18n from '../language/localization'
import { getByClient as getProductsDetail } from '../../api/products'
import { useAuth } from '../../hooks/useAuth'
import { useStore } from '../../hooks/useStore'
import { Badge, Container } from '@mui/material'
import { orderStatusCount } from 'api/order'
import { get as getCartAPI } from '../../api/cart'

const themeColor = JSON.parse(localStorage.getItem('themeColor'))
const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: 'none',
    color: 'black',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },

  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,

    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch'
    }
  },
  sectionDesktop: {
    position: 'relative',
    alignItems: 'center',
    display: 'none',
    '&>.MuiBadge-root .MuiBadge-anchorOriginTopRightRectangle': {
      top: 14,
      right: 15,
      background: '#e8eff4',
      color: 'black'
    },
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  notchedOutline: {
    borderColor: '#ff3a59 !important'
  },
  textSearch: {
    '& input::placeholder': {
      color: 'gray !important',
      opacity: 1
    },
    '& label.Mui-focused': {
      color: themeColor
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: themeColor
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: themeColor
      }
    }
  },
  textSearch2: {
    '&>.MuiAutocomplete-inputFocused': {
      borderColor: 'red !important'
    }
  },
  hoverStyle: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  ImgWrap: {
    width: 'auto',
    maxHeight: '60px',
    maxWidth: '200px',
    marginTop: '3px',

    '&:hover': {
      cursor: 'pointer'
    }
  },
  svgRoot: {
    margin: '0px !important'
  }
}))

const DeskTopHeader = ({ t, isFixed }) => {
  const auth = useAuth()
  const { store, landingPage, loadingLandingPage } = useStore()
  const { user, loadingGetProfile, loadingSetUser } = useAuth()
  const UserData = JSON.parse(localStorage.getItem('userdata'))
  const history = useHistory()

  const classes = useStyles()
  const [value, setValue] = useState('')
  const [myList] = useState([])

  const [myDataFilter, setMyFilterData] = useState([])
  const [cartQty, setCartQty] = useState(0)
  const [statusCount, setStatusCount] = useState({
    'WAITING APPROVAL HOD': 0,
    APPROVED: 0,
    ACKNOWLEDGE: 0,
    'ON DELIVERY': 0,
    COMPLETED: 0,
    'REJECTED HOD': 0,
    CANCELED: 0,
    TOTAL: 0,
    PO_STATUS: 0
  })

  const handleGetOrderStatusCount = async () => {
    try {
      const response = await orderStatusCount()
      setStatusCount(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const [isOpen, setOpen] = React.useState(false)

  const LoginFunction = async () => {
    setOpen(false)
  }

  const SignUpFunction = async () => {
    setOpen(false)
  }

  const searchProduct = async inputValue => {
    const response = await getProductsDetail(`{"query":"${inputValue}", "limit": 50}`)
    setMyFilterData(response.data)
  }

  const [debounce, setDebounce] = useState()
  const OnChangeSearchInput = async (event, newInputValue) => {
    clearTimeout(debounce)
    setDebounce(
      setTimeout(async () => {
        await searchProduct(newInputValue)
      }, 300)
    )
    setValue(newInputValue)
  }

  const searchPageClickWithInsertStory = async (event, valueSelected) => {
    if (!valueSelected.id) {
      localStorage.setItem('desktopSearch', JSON.stringify(valueSelected))
      history.push('/productsearch')
    } else {
      localStorage.setItem('desktopSearch', JSON.stringify(valueSelected.label))
      history.push(`/product-detail?${valueSelected.id}`)
    }
  }

  const [valueTabIndexOpen, setValueTabIndexOpen] = useState(0)
  const setOpenSignIn = async () => {
    setValueTabIndexOpen(0)
    setOpen(true)
  }
  const setOpenSignUp = async () => {
    setValueTabIndexOpen(1)
    setOpen(true)
  }
  const [openLogoutPopup, setOpenLogoutPopup] = useState(false)

  const closeModalLogout = () => {
    setOpenLogoutPopup(false)
  }
  const onOklogout = () => {
    auth.logout()

    closeModalLogout()
  }

  const getCart = async () => {
    const res = await getCartAPI()
    if (res?.data?.order_cart) {
      setCartQty(res.data.order_cart.item_quantity)
    }
  }

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
    handleGetOrderStatusCount()
  }, [])

  useEffect(() => {
    if (loadingLandingPage || loadingGetProfile || loadingSetUser) return
    if (user?.customer && landingPage) {
      setOpen(false)
    } else {
      if (landingPage) {
        if (
          landingPage.setting_customer &&
          landingPage.setting_customer.is_customer_required_login === true
        ) {
          setValueTabIndexOpen(0)
          history.push('/login')
        }
      }
    }
  }, [landingPage, user, loadingLandingPage, loadingGetProfile, loadingSetUser])

  useEffect(() => {
    if (user) {
      getCart()
    }
  }, [user])

  return (
    <div className={classes.grow}>
      <AppBar
        position='static'
        style={{
          background: 'white',
          position: isFixed ? 'fixed' : 'unset',
          boxShadow: 'none'
        }}
      >
        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              margin: '0px auto',
              height: 60,
              columnGap: 20
            }}
          >
            {store?.online_store ? (
              <img
                src='/logo.webp'
                width={200}
                height={40}
                onClick={() => history.push('/')}
                className={classes.ImgWrap}
                alt=''
              />
            ) : (
              <span style={{ cursor: 'pointer', color: 'black' }} onClick={() => history.push('/')}>
                {t('loadingdot')}
              </span>
            )}

            <Autocomplete
              freeSolo
              id='free-solo-2-demo'
              disableClearable
              style={{ width: '70%' }}
              options={
                myDataFilter
                  ? myDataFilter.length > 0
                    ? myDataFilter.map(option => ({
                        id: option.product.id,
                        label: option.product.name
                      }))
                    : myList.map(option => ({
                        id: option.product_id,
                        label: option.name
                      }))
                  : myList.map(option => ({
                      id: option.product_id,
                      label: option.name
                    }))
              }
              onInputChange={OnChangeSearchInput}
              onChange={(e, value) => searchPageClickWithInsertStory(e, value)}
              getOptionLabel={option => {
                if (option.label) {
                  option = option.label
                }
                return option
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment
                        position='end'
                        onClick={e => searchPageClickWithInsertStory(e, value)}
                      >
                        <SearchIcon style={{ color: 'gray' }} />
                      </InputAdornment>
                    )
                  }}
                  id='inputWith-icon-textfield'
                  variant='outlined'
                  placeholder={t('search_product_here_web')}
                  size='small'
                  className={classes.textSearch}
                />
              )}
              renderOption={(props, option) => {
                const matches = match(props.label, option.inputValue, {
                  insideWords: true
                })
                const parts = parse(props.label, matches)
                return (
                  <li {...props.label}>
                    <div>
                      {parts.map((part, index) => (
                        <span
                          key={index}
                          style={{
                            fontWeight: part.highlight ? 700 : 400,
                            color: part.highlight ? themeColor : 'black'
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </div>
                  </li>
                )
              }}
            />

            <div
              className={classes.sectionDesktop}
              style={{
                marginLeft: 'auto'
              }}
            >
              <div
                className={classes.sectionDesktop}
                onClick={() => {
                  UserData ? history.push('/orders') : setOpen(true)
                }}
                style={{ width: '96px' }}
              >
                <Badge
                  badgeContent={statusCount['WAITING APPROVAL HOD']}
                  color='primary'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: '-5px',
                      top: '10px',
                      backgroundColor: '#ff3a59'
                    }
                  }}
                >
                  <div>
                    <svg
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M3.17017 7.43994L12.0002 12.5499L20.7701 7.46991'
                        stroke='#404040'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M12.0002 21.61V12.54'
                        stroke='#404040'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M9.93011 2.48L4.59012 5.45003C3.38012 6.12003 2.39014 7.80001 2.39014 9.18001V14.83C2.39014 16.21 3.38012 17.89 4.59012 18.56L9.93011 21.53C11.0701 22.16 12.9401 22.16 14.0801 21.53L19.4201 18.56C20.6301 17.89 21.6201 16.21 21.6201 14.83V9.18001C21.6201 7.80001 20.6301 6.12003 19.4201 5.45003L14.0801 2.48C12.9301 1.84 11.0701 1.84 9.93011 2.48Z'
                        stroke='#404040'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M17 13.2401V9.58014L7.51001 4.1001'
                        stroke='#404040'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    <span style={{ color: 'black', cursor: 'pointer' }}>Orders</span>
                  </div>
                </Badge>
              </div>
              <div
                className={classes.sectionDesktop}
                onClick={() => {
                  UserData ? history.push('/carts') : setOpen(true)
                }}
              >
                <Badge
                  badgeContent={cartQty}
                  color='secondary'
                  style={{ marginLeft: 28, marginRight: 10 }}
                  sx={{
                    '& .MuiBadge-badge': {
                      right: '-5px',
                      top: '10px',
                      backgroundColor: '#ff3a59'
                    }
                  }}
                >
                  <div>
                    <svg
                      width={24}
                      height={24}
                      style={{ fill: 'transparent', fontSize: 31, width: 24 }}
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001'
                        stroke='#2B2B2B'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M16.25 22C16.9404 22 17.5 21.4404 17.5 20.75C17.5 20.0596 16.9404 19.5 16.25 19.5C15.5596 19.5 15 20.0596 15 20.75C15 21.4404 15.5596 22 16.25 22Z'
                        stroke='#2B2B2B'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M8.25 22C8.94036 22 9.5 21.4404 9.5 20.75C9.5 20.0596 8.94036 19.5 8.25 19.5C7.55964 19.5 7 20.0596 7 20.75C7 21.4404 7.55964 22 8.25 22Z'
                        stroke='#2B2B2B'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M9 8H21'
                        stroke='#2B2B2B'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    <span style={{ color: 'black', cursor: 'pointer' }}>Cart</span>
                  </div>
                </Badge>
              </div>
            </div>
            {UserData ? (
              <div>
                <span
                  style={{
                    paddingLeft: '8px',
                    fontSize: 16,
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '7px',
                    color: 'black'
                  }}
                  onClick={() => history.push('/my-profile')}
                  // onMouseOver={handleClick}
                  className={classes.hoverStyle}
                >
                  <Avatar
                    src={
                      UserData.profile_picture
                        ? process.env.REACT_APP_FILE_BASE_URL + '/' + UserData.profile_picture
                        : ''
                    }
                    style={{ height: 25, width: 25 }}
                  />
                  <div
                    style={{
                      flex: 1,
                      whiteSpace: 'nowrap',
                      maxWidth: '128px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {UserData.name}
                  </div>
                </span>
                {/* <Menu
                  id='simple-menu'
                  anchorEl={menuanchorEl}
                  keepMounted
                  open={Boolean(menuanchorEl)}
                  onClose={() => setmenuAnchorEl(null)}
                  MenuListProps={{ onMouseLeave: handleCloseWithoutDirect }}
                  PaperProps={{
                    style: {
                      marginTop: '50px'
                    }
                  }}
                >
                  <MenuItem onClick={() => handleClose(0)}>{t('my_profile')}</MenuItem>
                  <MenuItem onClick={() => handleClose(2)}>{t('my_order1')}</MenuItem>
                  <MenuItem onClick={() => handleClose(1)}>{t('my_address')}</MenuItem>
                  <MenuItem onClick={onOklogout}>{t('logout2')}</MenuItem>
                </Menu> */}
              </div>
            ) : (
              <>
                <Button
                  variant='outlined'
                  size='small'
                  style={{ color: themeColor, borderColor: themeColor }}
                  onClick={() => setOpenSignIn()}
                >
                  {t('login')}
                </Button>
                <Button
                  variant='contained'
                  size='small'
                  style={{ background: themeColor, color: 'white' }}
                  onClick={() => setOpenSignUp()}
                >
                  {t('register2')}
                </Button>
              </>
            )}
          </div>
        </Container>
      </AppBar>
      <AuthDilog
        open={isOpen}
        tabIndexOpen={valueTabIndexOpen}
        onClose={() => setOpen(false)}
        LoginFunction={LoginFunction}
        SignUpFunction={SignUpFunction}
      />

      <DialogAlert
        open={openLogoutPopup}
        close={closeModalLogout}
        yesno='true'
        no={closeModalLogout}
        ok={onOklogout}
      >
        {t('ask_logout')}
      </DialogAlert>
    </div>
  )
}
export default withNamespaces()(DeskTopHeader)
